import { render, staticRenderFns } from "./ProductAddons.vue?vue&type=template&id=82ca3e10"
import script from "./ProductAddons.vue?vue&type=script&lang=js"
export * from "./ProductAddons.vue?vue&type=script&lang=js"
import style0 from "./ProductAddons.vue?vue&type=style&index=0&id=82ca3e10&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports